import { ELCLogger } from 'elc-logging';

const logger: ELCLogger = new ELCLogger('elc-ecomm');

export const startMark = (name: string) => {
    try {
        performance.mark(`ecomm_app_${name}`);
    } catch (error) {
        logger.error({
            message: `[elc-ecomm]: ${error}`,
            triggerType: 'error'
        });
    }
};

export const endMark = (name: string) => {
    try {
        performance.mark(`ecomm_app_${name}_end`);
        performance.measure(
            `ecomm_app_measure_${name}`,
            `ecomm_app_${name}`,
            `ecomm_app_${name}_end`
        );
    } catch (error) {
        logger.error({
            message: `[elc-ecomm]: ${error}`,
            triggerType: 'error'
        });
    }
};
